import { ContactsBirthdateWUT } from '@wix/form-fields/viewer-wut';

export default ContactsBirthdateWUT;
